// Project home › ••• (SPEC F7): Export project (JSON) and Export with audio (zip with the kit's sounds).
// The export code, and the zip library with it, loads only on the tap. Delivery is the shared path of every
// export: the share sheet when the browser can, else a download (DECISIONS 2026-10-07).
import { useState } from 'react';
import { useAppStore } from '../../app/store';
import type { Project } from '../../data/types';
import { BottomSheet } from '../../ui/BottomSheet';
import { Row, RowList } from '../../ui/Row';
import { Progress } from '../../ui/States';
import { shareExport } from '../drums/exportActions';
import styles from './Beat.module.css';

export function ProjectMoreSheet({ open, project, onClose }: { open: boolean; project: Pick<Project, 'id' | 'name'>; onClose: () => void }) {
  const showToast = useAppStore((s) => s.showToast);
  const [busy, setBusy] = useState<'json' | 'zip'>();

  const run = async (audio: boolean) => {
    setBusy(audio ? 'zip' : 'json');
    try {
      const { buildProjectExport } = await import('../../export/projectExport');
      const made = await buildProjectExport(project.id, { audio, appVersion: __APP_VERSION__ });
      if (!made) {
        showToast({ message: "This project isn't on this device any more" });
        return;
      }
      onClose();
      await shareExport({ fileName: made.fileName, bytes: made.bytes, type: made.type, what: `${made.fileName} (${made.what})` });
    } catch (e) {
      console.warn('project export failed', e);
      showToast({ message: "The project couldn't be exported. Nothing was changed." });
    } finally {
      setBusy(undefined);
    }
  };

  return (
    <BottomSheet open={open} title={project.name} onClose={onClose}>
      <div className={styles.sheetBody}>
        <RowList label="Project actions">
          <li><Row title="Export project" meta="A .json file: the project, its kit settings, groove, marks, notes and journal" onClick={busy ? undefined : () => void run(false)} /></li>
          <li><Row title="Export with audio" meta="A .zip that also carries the kit's sounds, to open on another device" onClick={busy ? undefined : () => void run(true)} /></li>
        </RowList>
        <Progress active={Boolean(busy)} label="Making the file" />
      </div>
    </BottomSheet>
  );
}
